import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiClient } from '@app/core/services/base-api-client.service';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { KpaReturnResult } from '@app/core/models/kpa-return-result';
import { Observable, catchError, tap } from 'rxjs';
import { SdsLocation } from '../models/sds-location';
import { SDSDetails } from '../models/sds-details';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
export interface ISdsService {
	url: string;
	getLocation(): Observable<SdsLocation[]>;
	getDetails(sdsId: number): Observable<SDSDetails>;
}
@Injectable({
	providedIn: 'root',
})
export class SdsService extends BaseApiClient implements ISdsService {
	/**
	 * The base URL for the API domain.
	 */
	public baseUrl: string;

	/**
	 * The URL to the API endpoint.
	 */
	public url: string;

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		private readonly loadingIndicatorService: LoadingIndicatorService,
		environment: Environment
	) {
		super();
		this.baseUrl = environment.services['employee'];
		this.url = this.baseUrl + 'sds';
	}

	/**
	 * Get list of Locations
	 */
	getLocation(): Observable<SdsLocation[]> {
		const url = `${this.url}/location`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.get<SdsLocation[]>(url, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}

	/**
	 * Get details
	 */
	getDetails(sdsId: number): Observable<SDSDetails> {
		const url = `${this.url}/SdsById?sdsId=${sdsId}`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.get<SDSDetails>(url, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
}
